import {combineReducers} from 'redux';
import { Reducer } from 'redux';

export type ReducerMap = {
    [stateKey: string]: Reducer<any>
}

export default function createReducer(dynamicReducers: ReducerMap) {
    return combineReducers(dynamicReducers) as Reducer<{}>;
}
